import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/reports/partners-categories/filter'; // Importing Filter component
import Table from 'views/reports/partners-categories/table'; // Importing Table component

/**
 * PartnersCategoriesView class extends JetView to create a specific view for partners categories.
 */
export default class PartnersCategoriesView extends JetView {
    /**
     * Configures the UI components for the view.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for internationalization
        const left = {
            rows: [Filter, Table], // Layout containing Filter and Table components
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Type of the view
            view: 'form', // Main view type
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive design identifier
                    type: 'wide', // Type of the column layout
                    cols: [left], // Columns layout containing the left section
                },
            ],
        };
    }

    /**
     * Initializes the view. Currently empty but can be used for setup tasks.
     */
    init() {}
}

// FILE DOCUMENTED
